export default __webpack_public_path__ + "static/media/Home_IMG-03.73986fde.png";